import { Link } from "react-router-dom";
import { hotComics } from "@/mocks/homeData";

export default function HotComicsSection() {
  return (
    <section id="hot" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            人气推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 text-balance">
            热门<span className="text-primary-500">漫画</span>推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选平台最受欢迎的漫画作品，每日更新，精彩不断
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.title}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-xl aspect-[2/3] bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 51漫画热门推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="font-heading text-sm md:text-base font-bold text-background-50 leading-tight">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-300 mt-0.5">{comic.author}</p>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-foreground-950/60 text-accent-400 text-xs font-medium">
                  <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
                  {comic.rating}
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-1">
                {comic.tags.map((tag) => (
                  <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                    {tag}
                  </span>
                ))}
              </div>
              <p className="text-xs text-foreground-400 mt-1">
                <i className="ri-eye-line w-3 h-3 inline-flex items-center justify-center"></i> {comic.views}
              </p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-200 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-all duration-300 whitespace-nowrap"
          >
            查看更多漫画
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}